import { useMemo } from 'react';
import I18n from 'I18n';
import { usePortalData } from '../data/usePortalData';
export const useTicketListingsHeading = () => {
  var _data$settings;
  const {
    data
  } = usePortalData();
  const ticketLabelOverride = data === null || data === void 0 || (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : _data$settings.ticketLabelOverride;
  return useMemo(() => {
    return ticketLabelOverride || I18n.text('customer-portal-app.ticketListings.heading.default');
  }, [ticketLabelOverride]);
};